// extracted by mini-css-extract-plugin
export default {"colorSchemeSelector":"ColorSchemeSelector_colorSchemeSelector__Way3T","icon":"ColorSchemeSelector_icon__5h3H8"};